var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"icon",attrs:{"viewBox":"0 0 8 8"}},[_c('use',{attrs:{"xlink:href":_vm.href}}),_vm._v("' +\n")])}
var staticRenderFns = []

export { render, staticRenderFns }